import {ErrorHandler, Injectable} from '@angular/core';
import {environment} from '../environments/environment';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
    
    private errorMessage: string;
    private errorTimestamp: number = 0; // ALTERADO PELA PGE-RS: adicionado.

    // ALTERADO PELA PGE-RS: adicionado.
    constructor() {
        window.addEventListener('unhandledrejection', (event) => {
            this.handleError(event.reason instanceof Error 
                ? event.reason 
                : new Error(String(event.reason))
            );
        });
    }

    handleError(error: Error): void {

        // ALTERADO PELA PGE-RS: chunk desatualizado após deploy — recarrega silenciosamente
        if (error?.message?.includes('Failed to fetch dynamically imported module')) {
            window.location.reload();
            return;
        }

        // ALTERADO PELA PGE-RS: adicionado.
        if (error?.stack?.includes('chrome-extension://') || 
            error?.stack?.includes('moz-extension://')) {
            return;
        }

        // ALTERADO PELA PGE-RS: adicionado.
        const now = Date.now();
        if (error.message === this.errorMessage && (now - this.errorTimestamp) < 5000) {
            return;
        }

        if (error.message === this.errorMessage || (error.name === 'NotFoundError' && error.message.includes("removeChild"))) {
            return;
        }
        this.errorMessage = error.message;
        this.errorTimestamp = now; // ALTERADO PELA PGE-RS: adicionado.
        console.log (error);
        const path = 'log_collector';
        if (window.location.pathname.indexOf('ckeditor') > -1) {
            alert('Inconsistência detectada, favor salvar o trabalho manualmente em outro local e recarregar o editor!');
        }
        fetch(
            `${environment.base_url}${path}` + environment.xdebug,
            {
                method: 'POST',
                headers: {
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    message: error.message,
                    stack: error.stack,
                    url: window.location.pathname
                })
            }
        ).then();
    }
}
